export default "__VITE_ASSET__Qahr8A0WmjDwagtmAz_nMg__"